export const SECTIONS = [
  { key: "meta", label: "Page Info", icon: "", required: true },
  { key: "hero", label: "Hero", icon: "" },
  { key: "features", label: "Features", icon: "" },
  { key: "stats", label: "Stats", icon: "" },
  { key: "caseStudies", label: "Case Studies", icon: "" },
  { key: "faq", label: "FAQ", icon: "" },
  { key: "team", label: "Team", icon: "" },
  { key: "testimonials", label: "Testimonials", icon: "" },
  { key: "pricing", label: "Pricing", icon: "" },
  { key: "footer", label: "Footer", icon: "" },
  { key: "contact", label: "Contact CTA", icon: "" },
];
